import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  TextField,
  Stepper,
  StepLabel,
  Step,
  StepContent,
  Button,
} from '@mui/material';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import { showNotification, createComplaint } from '../../redux/actions';

class HelpDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      currentComplaint: '',
    };
  }

  onClose = () => {
    const { onClose } = this.props;
    this.setState({
      activeStep: 0,
    });

    onClose();
  };

  helpStep = () => {
    this.setState({
      activeStep: 0,
    });
  };

  complaintStep = () => {
    this.setState({
      activeStep: 1,
    });
  };

  updateComplaint = (event, complaintText) => {
    this.setState({
      currentComplaint: complaintText,
    });
  };

  sendComplaint = () => {
    const {
      id, userId, sendComplaint, showNotification: showPropsNotification, onClose,
    } = this.props;
    const { currentComplaint } = this.state;
    sendComplaint({
      helpId: id,
      complaintText: currentComplaint,
      quipUserId: userId,
    });

    showPropsNotification(<FormattedMessage id="help.complaintSent" />);
    onClose();
  };

  render() {
    const { isOpen, id } = this.props;
    const { activeStep, currentComplaint } = this.state;
    return (
      <GenericDialog isOpen={isOpen}>
        <ContentBox title={<FormattedMessage id={`${id}.helpTitle`} />}>
          <Stepper activeStep={activeStep} orientation="vertical">
            <Step>
              <StepLabel active>
                <FormattedMessage id="help.dialogStep" />
              </StepLabel>
              <StepContent className="flex-column">
                <p><FormattedMessage id={`${id}.helpText`} /></p>
                <Button
                  variant="contained"
                  onClick={this.complaintStep}
                  color="secondary"
                >
                  <FormattedMessage id="help.complaint" />
                </Button>
              </StepContent>
            </Step>
            <Step>
              <StepLabel>
                <FormattedMessage id="help.complaintStep" />
              </StepLabel>
              <StepContent>
                <div>
                  <TextField
                    id="HelpComplaintTextField"
                    style={{ width: '100%' }}
                    onChange={this.updateComplaint}
                    rows={4}
                    multiline
                    maxRows={10}
                    label={<FormattedMessage id="help.complaintFormHint" />}
                    variant="standard"
                  />
                </div>
                <div>
                  <Button variant="contained" onClick={this.helpStep} secondary><FormattedMessage id="back" /></Button>
                  <Button
                    variant="contained"
                    className="mt2 ml2"
                    onClick={this.sendComplaint}
                    disabled={!currentComplaint}
                    color="primary"
                  >
                    <FormattedMessage id="help.complaintSend" />
                  </Button>
                </div>
              </StepContent>
            </Step>
          </Stepper>
          <div className="tr">
            <Button
              variant="contained"
              className="dib"
              onClick={this.onClose}
              color="primary"
            >
              <FormattedMessage id="genericClose" />
            </Button>
          </div>
        </ContentBox>
      </GenericDialog>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.users.token && state.users.token.userId,
});

const mapDispatchToProps = (dispatch) => ({
  showNotification: (message) => dispatch(showNotification(message)),
  sendComplaint: (complaintData) => dispatch(createComplaint(complaintData)),
});

HelpDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  sendComplaint: PropTypes.func.isRequired,
  userId: PropTypes.number,
};

HelpDialog.defaultProps = {
  userId: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpDialog);
